import React from 'react';
import useEncryptedLectureVideo from '../../hooks/useEncryptedLectureVideo';
import CustomYouTubePlayer from './CustomYouTubePlayer';

export default function YouTubeLecturePlayer({ lectureId, title }) {
  const { videoId, loading, error, retry } = useEncryptedLectureVideo(lectureId);

  return (
    <div className="ml-iframe-responsive-wrapper">
      {loading && (
        <div className="ml-video-player-state ml-video-player-loading" role="status" aria-label="Loading lesson video" />
      )}
      {error && (
        <div className="ml-video-player-state ml-video-player-error" role="alert">
          <p>{error}</p>
          <button type="button" onClick={retry}>Try again</button>
        </div>
      )}
      {videoId && (
        <CustomYouTubePlayer
          videoUrl={`https://www.youtube.com/embed/${videoId}`}
          title={title || 'Course lesson video'}
        />
      )}
    </div>
  );
}
